// Smooth scrolling for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Lady Section Slider
function initLadySlider() {
    const slides = document.querySelectorAll('.lady-slide');
    const dots = document.querySelectorAll('.lady-dot');
    const prevBtn = document.querySelector('.lady-slider-prev');
    const nextBtn = document.querySelector('.lady-slider-next');

    if (!slides.length || !dots.length || !prevBtn || !nextBtn) return;

    let currentSlide = 0;
    let slideInterval;

    // Function to show specific slide
    function showSlide(index) {
        // Check if we're on mobile
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // On mobile, hide all slides first, then show the active one
            slides.forEach((slide, i) => {
                slide.classList.remove('active');
                if (i === index) {
                    slide.style.display = 'flex';
                    slide.classList.add('active');
                } else {
                    slide.style.display = 'none';
                }
            });
        } else {
            // On desktop, use opacity transitions
            slides.forEach(slide => slide.classList.remove('active'));
            slides[index].classList.add('active');
        }

        // Update dots
        dots.forEach(dot => dot.classList.remove('active'));
        dots[index].classList.add('active');

        currentSlide = index;
    }

    // Function to go to next slide
    function nextSlide() {
        const next = (currentSlide + 1) % slides.length;
        showSlide(next);
    }

    // Function to go to previous slide
    function prevSlide() {
        const prev = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(prev);
    }

    // Function to start auto-sliding
    function startAutoSlide() {
        slideInterval = setInterval(nextSlide, 5000); // Change slide every 5 seconds
    }

    // Function to stop auto-sliding
    function stopAutoSlide() {
        clearInterval(slideInterval);
    }

    // Event listeners for navigation buttons
    nextBtn.addEventListener('click', () => {
        nextSlide();
        stopAutoSlide();
        startAutoSlide(); // Restart auto-slide after manual navigation
    });

    prevBtn.addEventListener('click', () => {
        prevSlide();
        stopAutoSlide();
        startAutoSlide(); // Restart auto-slide after manual navigation
    });

    // Event listeners for dots
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            showSlide(index);
            stopAutoSlide();
            startAutoSlide(); // Restart auto-slide after manual navigation
        });
    });

    // Pause auto-slide on hover and touch
    const sliderContainer = document.querySelector('.lady-slider-container');
    if (sliderContainer) {
        sliderContainer.addEventListener('mouseenter', stopAutoSlide);
        sliderContainer.addEventListener('mouseleave', startAutoSlide);
        sliderContainer.addEventListener('touchstart', stopAutoSlide);
        sliderContainer.addEventListener('touchend', () => {
            setTimeout(startAutoSlide, 3000); // Resume after 3 seconds on mobile
        });
    }

    // Add touch swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    function handleSwipe() {
        const swipeThreshold = 50;
        const swipeDistance = touchEndX - touchStartX;

        if (Math.abs(swipeDistance) > swipeThreshold) {
            if (swipeDistance > 0) {
                prevSlide(); // Swipe right - go to previous slide
            } else {
                nextSlide(); // Swipe left - go to next slide
            }
            stopAutoSlide();
            startAutoSlide();
        }
    }

    if (sliderContainer) {
        sliderContainer.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        });

        sliderContainer.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        });
    }

    // Handle window resize to switch between mobile and desktop behavior
    function handleResize() {
        showSlide(currentSlide); // Re-apply current slide with correct behavior
    }

    window.addEventListener('resize', handleResize);

    // Initialize with correct behavior
    showSlide(0);

    // Start auto-sliding
    startAutoSlide();
}

// Horizontal Parallax Effect for Services Section
function initServicesParallax() {
    const servicesImageBg = document.querySelector('.services-image-bg');
    const servicesSection = document.querySelector('.services-section');

    if (!servicesImageBg || !servicesSection) return;

    let ticking = false;

    function updateParallax() {
        const rect = servicesSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calculate how much of the section is visible
        const sectionTop = rect.top;
        const sectionHeight = rect.height;

        // Only apply parallax when section is in viewport
        if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
            // Calculate scroll progress through the section (0 to 1)
            const scrollProgress = Math.max(0, Math.min(1, (windowHeight - sectionTop) / (windowHeight + sectionHeight)));

            // Move image horizontally based on scroll progress
            // Moves from left to right as user scrolls down (opposite direction)
            const translateX = (0.5 - scrollProgress) * 50; // Opposite direction from lady section

            servicesImageBg.style.transform = `translateX(${translateX}px)`;
        }

        ticking = false;
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateParallax);
            ticking = true;
        }
    }

    // Listen for scroll events
    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial call
    updateParallax();
}

// Responsive Menu Functionality
function initMenubarMenu() {
    const menubar = document.getElementById('menubar');
    const mainMenu = document.getElementById('main-menu');

    if (!menubar || !mainMenu) {
        console.log('Menubar or main menu not found');
        return;
    }

    function openMenu() {
        menubar.classList.add('active');
        menubar.setAttribute('aria-expanded', 'true');
        mainMenu.classList.add('mobile-open');
        // Add active class after a small delay for smooth animation
        setTimeout(() => {
            mainMenu.classList.add('active');
        }, 10);
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        menubar.classList.remove('active');
        menubar.setAttribute('aria-expanded', 'false');
        mainMenu.classList.remove('active');
        // Remove mobile-open class after animation completes
        setTimeout(() => {
            mainMenu.classList.remove('mobile-open');
        }, 300);
        document.body.style.overflow = '';

        // Close all dropdowns
        const dropdownItems = mainMenu.querySelectorAll('.dropdown-item');
        dropdownItems.forEach(item => {
            item.classList.remove('mobile-open');
        });
    }

    menubar.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (mainMenu.classList.contains('mobile-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    // Close menu when clicking on navigation links (but not dropdown toggles)
    const navLinks = mainMenu.querySelectorAll('a:not(.dropdown-toggle)');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            closeMenu();
        });
    });

    // Handle dropdown menu
    const dropdownItems = mainMenu.querySelectorAll('.dropdown-item');
    dropdownItems.forEach(item => {
        const toggle = item.querySelector('.dropdown-toggle');
        if (toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                // Close other dropdowns
                dropdownItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('mobile-open');
                    }
                });

                // Toggle current dropdown
                item.classList.toggle('mobile-open');
            });
        }
    });

    // Close menu when clicking outside (only when menu is open)
    document.addEventListener('click', function(e) {
        if (mainMenu.classList.contains('mobile-open') &&
            !menubar.contains(e.target) &&
            !mainMenu.contains(e.target)) {
            closeMenu();
        }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768) {
            closeMenu();
        }
    });

    // Handle escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mainMenu.classList.contains('mobile-open')) {
            closeMenu();
        }
    });
}

// Image Slider Functionality for Retreats Page
function initImageSlider() {
    const sliderContainers = document.querySelectorAll('.retreat-slider-container');

    sliderContainers.forEach(container => {
        const slider = container.querySelector('.image-slider');
        const images = slider.querySelectorAll('img');
        const dots = container.querySelectorAll('.dot');

        // Find the initially active slide
        let currentSlide = 0;
        images.forEach((img, index) => {
            if (img.classList.contains('active')) {
                currentSlide = index;
            }
        });

        // Auto advance slides
        function nextSlide() {
            images[currentSlide].classList.remove('active');
            dots[currentSlide].classList.remove('active');

            currentSlide = (currentSlide + 1) % images.length;

            images[currentSlide].classList.add('active');
            dots[currentSlide].classList.add('active');
        }

        // Set up dot click handlers
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                images[currentSlide].classList.remove('active');
                dots[currentSlide].classList.remove('active');

                currentSlide = index;

                images[currentSlide].classList.add('active');
                dots[currentSlide].classList.add('active');
            });
        });

        // Auto advance every 5 seconds
        setInterval(nextSlide, 5000);
    });
}

// Tab Functionality for Media Page
function initTabFunctionality() {
    // Find all tab links
    const tabLinks = document.querySelectorAll('[data-toggle="tab"]');
    const tabPanes = document.querySelectorAll('.tab-pane');

    if (tabLinks.length === 0) return; // Exit if no tabs found

    // Function to show a specific tab
    function showTab(targetId, clickedLink) {
        // Remove active classes from all tabs and panes
        tabLinks.forEach(link => {
            link.classList.remove('active', 'show');
        });

        tabPanes.forEach(pane => {
            pane.classList.remove('active', 'show');
            pane.classList.add('hide');
        });

        // Add active class to clicked tab
        clickedLink.classList.add('active', 'show');

        // Show target content - handle IDs that start with numbers
        let targetPane;
        if (targetId && targetId.startsWith('#')) {
            const id = targetId.substring(1); // Remove the #
            targetPane = document.getElementById(id);
        }

        if (targetPane) {
            targetPane.classList.remove('hide');
            targetPane.classList.add('active', 'show');
        }
    }

    // Add click event listeners to all tab links
    tabLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            if (targetId && targetId.startsWith('#')) {
                showTab(targetId, this);
            }
        });
    });

    // Initialize first tab as active if none are active
    const activeTab = document.querySelector('[data-toggle="tab"].active');
    const activePane = document.querySelector('.tab-pane.active');

    if (!activeTab && !activePane && tabLinks.length > 0) {
        const firstTab = tabLinks[0];
        const firstTargetId = firstTab.getAttribute('href');
        showTab(firstTargetId, firstTab);
    }
}

// Testimonials Slider
function initTestimonialsSlider() {
    const track = document.querySelector('.testimonials-track');
    const cards = document.querySelectorAll('.testimonial-card');
    const dots = document.querySelectorAll('.testimonial-dot');
    const prevBtn = document.querySelector('.testimonials-arrow-left');
    const nextBtn = document.querySelector('.testimonials-arrow-right');

    if (!track || !cards.length || !dots.length || !prevBtn || !nextBtn) return;

    let currentSlide = 0;
    let slideInterval;

    // Function to get cards per view based on screen size
    function getCardsPerView() {
        return window.innerWidth <= 768 ? 1 : 3;
    }

    // Function to get maximum slide index
    function getMaxSlide() {
        const cardsPerView = getCardsPerView();
        return Math.max(0, cards.length - cardsPerView);
    }

    // Function to update slider position
    function updateSlider() {
        const cardsPerView = getCardsPerView();
        const cardWidth = 100 / cardsPerView;
        const translateX = -(currentSlide * cardWidth);
        track.style.transform = `translateX(${translateX}%)`;

        // Update dots
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentSlide);
        });
    }

    // Function to go to next slide
    function nextSlide() {
        const maxSlide = getMaxSlide();
        currentSlide = currentSlide >= maxSlide ? 0 : currentSlide + 1;
        updateSlider();
    }

    // Function to go to previous slide
    function prevSlide() {
        const maxSlide = getMaxSlide();
        currentSlide = currentSlide <= 0 ? maxSlide : currentSlide - 1;
        updateSlider();
    }

    // Function to go to specific slide
    function goToSlide(index) {
        const maxSlide = getMaxSlide();
        currentSlide = Math.min(index, maxSlide);
        updateSlider();
    }

    // Function to start auto-sliding
    function startAutoSlide() {
        slideInterval = setInterval(nextSlide, 5000); // Change slide every 5 seconds
    }

    // Function to stop auto-sliding
    function stopAutoSlide() {
        clearInterval(slideInterval);
    }

    // Event listeners for navigation buttons
    nextBtn.addEventListener('click', () => {
        nextSlide();
        stopAutoSlide();
        startAutoSlide(); // Restart auto-slide after manual navigation
    });

    prevBtn.addEventListener('click', () => {
        prevSlide();
        stopAutoSlide();
        startAutoSlide(); // Restart auto-slide after manual navigation
    });

    // Event listeners for dots
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            goToSlide(index);
            stopAutoSlide();
            startAutoSlide(); // Restart auto-slide after manual navigation
        });
    });

    // Pause auto-slide on hover
    const sliderContainer = document.querySelector('.testimonials-slider');
    if (sliderContainer) {
        sliderContainer.addEventListener('mouseenter', stopAutoSlide);
        sliderContainer.addEventListener('mouseleave', startAutoSlide);
    }

    // Handle window resize
    function handleResize() {
        const maxSlide = getMaxSlide();
        if (currentSlide > maxSlide) {
            currentSlide = maxSlide;
        }
        updateSlider();
    }

    window.addEventListener('resize', handleResize);

    // Initialize slider
    updateSlider();
    startAutoSlide();
}

// Services Slider (3 cards visible, center one bigger)
function initServicesSlider() {
    const track = document.querySelector('.services-slider-track');
    const cards = document.querySelectorAll('.services-slider-track .service-card-link');
    const prevBtn = document.querySelector('.services-arrow-prev');
    const nextBtn = document.querySelector('.services-arrow-next');

    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    const totalCards = 3; // Original cards count
    let currentIndex = 1; // Start at index 1 to show middle card centered
    let isTransitioning = false;

    function getCardDimensions() {
        const width = window.innerWidth;
        if (width <= 480) {
            return { cardWidth: 100, gap: 10 };
        } else if (width <= 768) {
            return { cardWidth: 200, gap: 20 };
        } else {
            return { cardWidth: 300, gap: 30 };
        }
    }

    function updateSlider(smooth = true) {
        const { cardWidth, gap } = getCardDimensions();

        if (!smooth) {
            track.style.transition = 'none';
        } else {
            track.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        }

        // Calculate offset to show 3 cards with middle one centered
        // Position: [left card][CENTER CARD][right card]
        const offset = currentIndex * (cardWidth + gap);
        track.style.transform = `translateX(calc(50% - ${offset}px - ${cardWidth / 2}px))`;

        // Update center card styling
        cards.forEach((card, index) => {
            card.classList.remove('center-card');
            if (index === currentIndex) {
                card.classList.add('center-card');
            }
        });

        // Handle infinite loop
        if (smooth) {
            setTimeout(() => {
                if (currentIndex >= totalCards + 1) {
                    currentIndex = 1;
                    updateSlider(false);
                } else if (currentIndex <= 0) {
                    currentIndex = totalCards;
                    updateSlider(false);
                }
                isTransitioning = false;
            }, 600);
        }
    }

    function nextSlide() {
        if (isTransitioning) return;
        isTransitioning = true;
        currentIndex++;
        updateSlider(true);
    }

    function prevSlide() {
        if (isTransitioning) return;
        isTransitioning = true;
        currentIndex--;
        updateSlider(true);
    }

    prevBtn.addEventListener('click', prevSlide);
    nextBtn.addEventListener('click', nextSlide);

    // Auto-slide every 4 seconds
    let autoSlideInterval = setInterval(nextSlide, 4000);

    // Pause auto-slide on hover
    track.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
    track.addEventListener('mouseleave', () => {
        autoSlideInterval = setInterval(nextSlide, 4000);
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateSlider(false);
        }, 100);
    });

    // Initialize - start with middle card centered
    updateSlider(false);
}

// Products Slider (5 cards visible, center one bigger)
function initProductsSlider() {
    const track = document.querySelector('.products-slider-track');
    const cards = document.querySelectorAll('.products-slider-track .product-card-link');
    const prevBtn = document.querySelector('.products-arrow-prev');
    const nextBtn = document.querySelector('.products-arrow-next');

    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    const totalCards = 5; // Original cards count
    let currentIndex = 2; // Start at index 2 to show middle card (3rd card) centered
    let isTransitioning = false;

    function getCardDimensions() {
        const width = window.innerWidth;
        if (width <= 480) {
            return { cardWidth: 90, gap: 10 };
        } else if (width <= 768) {
            return { cardWidth: 140, gap: 15 };
        } else {
            return { cardWidth: 220, gap: 20 };
        }
    }

    function updateSlider(smooth = true) {
        const { cardWidth, gap } = getCardDimensions();

        if (!smooth) {
            track.style.transition = 'none';
        } else {
            track.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        }

        // Calculate offset to show 5 cards with middle one (3rd) centered
        // Position: [card1][card2][CENTER CARD][card4][card5]
        const offset = currentIndex * (cardWidth + gap);
        track.style.transform = `translateX(calc(50% - ${offset}px - ${cardWidth / 2}px))`;

        // Update center card styling
        cards.forEach((card, index) => {
            card.classList.remove('center-card');
            if (index === currentIndex) {
                card.classList.add('center-card');
            }
        });

        // Handle infinite loop
        if (smooth) {
            setTimeout(() => {
                if (currentIndex >= totalCards + 2) {
                    currentIndex = 2;
                    updateSlider(false);
                } else if (currentIndex <= 1) {
                    currentIndex = totalCards + 1;
                    updateSlider(false);
                }
                isTransitioning = false;
            }, 600);
        }
    }

    function nextSlide() {
        if (isTransitioning) return;
        isTransitioning = true;
        currentIndex++;
        updateSlider(true);
    }

    function prevSlide() {
        if (isTransitioning) return;
        isTransitioning = true;
        currentIndex--;
        updateSlider(true);
    }

    prevBtn.addEventListener('click', prevSlide);
    nextBtn.addEventListener('click', nextSlide);

    // Auto-slide every 4 seconds
    let autoSlideInterval = setInterval(nextSlide, 4000);

    // Pause auto-slide on hover
    track.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
    track.addEventListener('mouseleave', () => {
        autoSlideInterval = setInterval(nextSlide, 4000);
    });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateSlider(false);
        }, 100);
    });

    // Initialize - start with middle card (3rd) centered
    updateSlider(false);
}

// Hero Slider Functionality
function initHeroSlider() {
    const slides = document.querySelectorAll('.hero-slider-slide');
    const prevBtn = document.querySelector('.hero-slider-prev');
    const nextBtn = document.querySelector('.hero-slider-next');

    if (!slides.length || !prevBtn || !nextBtn) return;

    let currentSlide = 0;
    const totalSlides = slides.length;

    function showSlide(index) {
        // Remove active class from all slides
        slides.forEach(slide => {
            slide.classList.remove('active');
        });

        // Add active class to current slide
        slides[index].classList.add('active');
    }

    function nextSlide() {
        currentSlide = (currentSlide + 1) % totalSlides;
        showSlide(currentSlide);
    }

    function prevSlide() {
        currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
        showSlide(currentSlide);
    }

    // Event listeners for navigation buttons
    nextBtn.addEventListener('click', nextSlide);
    prevBtn.addEventListener('click', prevSlide);

    // Auto-advance slider every 5 seconds
    let autoSlideInterval = setInterval(nextSlide, 10000);

    // Pause auto-slide on hover
    const sliderWrapper = document.querySelector('.hero-slider-wrapper');
    if (sliderWrapper) {
        sliderWrapper.addEventListener('mouseenter', () => {
            clearInterval(autoSlideInterval);
        });

        sliderWrapper.addEventListener('mouseleave', () => {
            autoSlideInterval = setInterval(nextSlide, 10000);
        });
    }
}

// Text Testimonials Slider Functionality
function initTextTestimonialsSlider() {
    const slides = document.querySelectorAll('.text-testimonial-slide');
    const dots = document.querySelectorAll('.text-testimonial-dot');
    const prevBtn = document.querySelector('.text-testimonials-prev');
    const nextBtn = document.querySelector('.text-testimonials-next');
    const track = document.querySelector('.text-testimonials-track');

    if (!slides.length || !dots.length || !prevBtn || !nextBtn || !track) return;

    let currentSlide = 0;
    let slideInterval;

    function showSlide(index) {
        // Remove active class from all dots
        dots.forEach(dot => dot.classList.remove('active'));

        // Add active class to current dot
        dots[index].classList.add('active');

        // Move track
        const offset = index * 100;
        track.style.transform = `translateX(-${offset}%)`;

        currentSlide = index;
    }

    function nextSlide() {
        const next = (currentSlide + 1) % slides.length;
        showSlide(next);
    }

    function prevSlide() {
        const prev = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(prev);
    }

    function startAutoSlide() {
        slideInterval = setInterval(nextSlide, 5000); // 5 seconds per slide
    }

    function stopAutoSlide() {
        clearInterval(slideInterval);
    }

    // Event listeners for navigation buttons
    nextBtn.addEventListener('click', () => {
        nextSlide();
        stopAutoSlide();
        startAutoSlide();
    });

    prevBtn.addEventListener('click', () => {
        prevSlide();
        stopAutoSlide();
        startAutoSlide();
    });

    // Event listeners for dots
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            showSlide(index);
            stopAutoSlide();
            startAutoSlide();
        });
    });

    // Pause auto-slide on hover
    const sliderContainer = document.querySelector('.text-testimonials-slider-wrapper');
    if (sliderContainer) {
        sliderContainer.addEventListener('mouseenter', stopAutoSlide);
        sliderContainer.addEventListener('mouseleave', startAutoSlide);
    }

    // Start auto-sliding
    startAutoSlide();
}

// Modal Functionality
function initModal() {
    const modal = document.getElementById('formModal');
    const openButtons = document.querySelectorAll('.open-modal');
    const closeBtn = document.querySelector('.close-btn');

    if (!modal) return;

    // Open modal when button is clicked
    openButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            modal.classList.add('show');
            document.body.style.overflow = 'hidden'; // Prevent scrolling
        });
    });

    // Close modal when X is clicked
    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            modal.classList.remove('show');
            document.body.style.overflow = 'auto'; // Re-enable scrolling
        });
    }

    // Close modal when clicking outside the modal content
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            modal.classList.remove('show');
            document.body.style.overflow = 'auto'; // Re-enable scrolling
        }
    });

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('show')) {
            modal.classList.remove('show');
            document.body.style.overflow = 'auto'; // Re-enable scrolling
        }
    });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    initHeroSlider();
    initLadySlider();
    initTestimonialsSlider();
    initTextTestimonialsSlider();
    initServicesParallax();
    initMenubarMenu();
    initImageSlider();
    initTabFunctionality();
    initServicesSlider();
    initProductsSlider();
    initModal();
});